export const CertificatesEndpoint = {
    get: `${process.env.API_BACKEND}/v1/certificates/certificate/`,
} as const
